import React, { useEffect, useState } from 'react';
import { JSON_ONE } from "./JSON_DATA_Request";
import { JSON_ONE1 } from "./JSON_DATA_Response";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import ResponseJSON from './ResponseJSON';
import RequestJSON from './RequestJSON';
function RefundAPI() {
const [ShowHideAccordionOne, SetShowHideAccordionOne] = useState(false);
const [ShowHideAccordionTwo, SetShowHideAccordionTwo] = useState(false);
const onClickAccordianShowHideOne = () => {
SetShowHideAccordionOne(!ShowHideAccordionOne)
}
const onClickAccordianShowHideTwo = () => {
SetShowHideAccordionTwo(!ShowHideAccordionTwo)
}
const [TabCheck1, SetTabCheck1] = useState(false)
const [TabCheck2, SetTabCheck2] = useState(false)
const onClickCangeTab1 = () => {
SetTabCheck1(!TabCheck1);
}
const onClickCangeTab2 = () => {
SetTabCheck2(!TabCheck2);
}
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_layout1">
               <h1>Refund API</h1>
               <hr/>
            </section>
         </div>
         <div class="col-md-4 extreme-rt-div">
         </div>
      </div>
      <div class="row">
         <div class="col-md-8 mt-60">
            <h2>You can use the Refund API to initiate the refund</h2>
            <p>
               You can use the Refund API to initiate the refund for any transactions You can refund the amount fully or partially. Refund API uses JSON format and sent using RESTful Web Service.
            </p>
            <img class="img-fluid" src="assets/images/pg-images/refund1.png"/><br/><br/>
            <img class="img-fluid" src="assets/images/pg-images/refund2.png"/><br/><br/>
            <img class="img-fluid" src="assets/images/pg-images/refund3.png"/><br/><br/>
            <img class="img-fluid" src="assets/images/pg-images/refund4.png"/><br/><br/>
            <img class="img-fluid" src="assets/images/pg-images/refund5.png"/><br/><br/>
            <img class="img-fluid" src="assets/images/pg-images/refund6.png"></img>
            <p className="mt-30">
               <b>Aes256 Crypto logic</b> is used to encrypt and decrypt the JSON Request and Response parameters respectively.
            </p>
            <p>
               <b>Iv-initialization vector</b> can be used along with the Encryption key for data encryption and the value remained static which is mentioned in the Integration kit.
            </p>
            <p>Please follow below steps to process a refund at your end:</p>
            <h5>Postman Collection:</h5>
            <p>We are providing the postman collection to initiate the refund on easier way.</p>
            <p>Safexpay team will share you at the time of Integration.</p>
            <u>
               <p>UAT credentials to check the Refund API flow:</p>
            </u>
            <table>
               <tr>
                  <td>UAT Refund PostURL:</td>
                  <td width="5%"></td>
                  {/* <td>https://pguat.safexpay.com/agcore/api/refund/post</td> */}
                  <td>https://uatcheckout.safexpay.com/ms-transaction-core-1-0/api/verify/refundStatus</td>
               </tr>
               <tr>
                  <td>UAT Merchant ID:</td>
                  <td></td>
                  <td>202104210302</td>
               </tr>
               <tr>
                  <td>UAT Encryption Key:</td>
                  <td></td>
                  <td>N28808GWxE30Fz0z6wfxgEpSfPaQunLCU54vDity4</td>
               </tr>
               <tr>
                  <td>Aggregator ID:</td>
                  <td></td>
                  <td>Paypate</td>
               </tr>
               <tr>
                  <td>Live Refund PostURL:</td>
                  <td></td>
                  <td>https://checkout.safexpay.com/ms-transaction-core-1-0/api/verify/refundStatus</td>
               </tr>
               <tr>
                  <td>Live Merchant ID:</td>
                  <td></td>
                  <td>Shared by Safexpay</td>
               </tr>
               <tr>
                  <td>UAT Encryption Key:</td>
                  <td></td>
                  <td>Shared by Safexpay</td>
               </tr>
               <tr>
                  <td>Aggregator ID:</td>
                  <td></td>
                  <td>Paypate</td>
               </tr>
            </table>
            <h5 className='mt-20'>Plain Request Parameters: -</h5>
            <div class="form-data1">
            <pre id="json">{'\u007B'}{'\n'}
  “ag_id”: “paygate”{'\n'}
  “me_id”: “202104210302”{'\n'}
  “ag_ref”: “1010176361036299506”// Encryption Value{'\n'}
  “refund_amount”: “100” //Encryption Value{'\n'}
  “refund_reason”: “Test” //Encryption Value{'\n'}
  {'\u007D'}</pre>
            </div>
            <h5>Plain Request Parameters: -</h5>
            <div class="form-data1">
            <pre id="json">  {'\u007B'}{'\n'}
    "ag_id": "paygate", {'\n'}
    "me_id": "201701240003",{'\n'}
    "ag_ref": "893109158112952320",{'\n'}
    "refund_amount": "10", {'\n'}
    "currency": "INR",{'\n'}
    "txn_date": "2017-08-03",{'\n'}
    "txn_time": "19:30:17",{'\n'}
    "refund_ref": "0",{'\n'}
    "pg_ref": "PG_893109158112952320",{'\n'}
    "status":"FULL REFUND", {'\n'}
    "res_code": "00000", {'\n'}
    "res_message": "Refund",{'\n'}
    "error_details": null,{'\n'}
    "Is_settled": "Void"{'\n'}
    {'\u007D'}
</pre>
            </div>
            <u>
               <p>
                  AUTHORIZATIONS:
               </p>
            </u>
            <p className='mb-0'>REQUEST BODY SCHEMA: application/json</p>
            <hr className='hr-col'>
            </hr>
            <table class="sc-hHEiqL iZJLLY">
               <tbody>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Aggregator ID is “paygate”</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Merchant ID issued to you by Safexpay</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span class="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>AG_ref id generated by the Safexpay during the transaction.It should be encrypted format.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="refund_amount"><span class="sc-iemWCZ fhDkLh"></span><span>refund_amount</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Amount you want to Refund. You can use up to 2 decimal places.This amount should not be greater that Transaction Amount.It should be encrypted format.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr class="last undefined">
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="refund_reason"><span class="sc-iemWCZ fhDkLh"></span><span>refund_reason</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Reason for refunding the transaction.It should be encrypted format.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
            <h5 className="mt-60">Responses</h5>
            <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
               <div class="card">
                  <div class="card-header" id="heading1">
                     <h5 class="mb-0">
                        <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                        <b>200</b> A refund reponse json object {TabCheck1 ?
                        <FaAngleUp />
                        :
                        <FaAngleDown />
                        }
                  </div>
                  </h5>
               </div>
               {
               TabCheck1 &&
               <div>
                  <div class="card-body">
                     <h6 class="mt-10"><span>RESPONSE SCHEMA: </span> <span style={{ color: "#313131" }}>application/json</span></h6>
                     <hr class="hr-col">
                     </hr>
                     <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Aggregator ID. Use “safexpay” here.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Merchant ID issued to you by safexpay.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span class="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>AG_ref id generated by the safexpay during the transaction.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="refund_amount"><span class="sc-iemWCZ fhDkLh"></span><span>refund_amount</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Refund Amount.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="currency"><span class="sc-iemWCZ fhDkLh"></span><span>currency</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>ISO currency code. E.g. “INR” for India..</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_date"><span class="sc-iemWCZ fhDkLh"></span><span>txn_date</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Format DD-MM-YYYY. E.g. 26-11-2015.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_time"><span class="sc-iemWCZ fhDkLh"></span><span>txn_time</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Format HH.MM  SS. E.g. 23:30:50.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="refund_ref"><span class="sc-iemWCZ fhDkLh"></span><span>refund_ref</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Refund Reference Number generated by safexpay.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_ref"><span class="sc-iemWCZ fhDkLh"></span><span>pg_ref</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>PG_ref generated by gateway for your refund.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>“Successful”, “Failed” or “Pending”.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_code"><span class="sc-iemWCZ fhDkLh"></span><span>res_code</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Response Code. 0 for Success.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_message"><span class="sc-iemWCZ fhDkLh"></span><span>res_message</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Failure Reason.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="error_details"><span class="sc-iemWCZ fhDkLh"></span><span>error_details</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>error details.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr class="last undefined">
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Is_settled"><span class="sc-iemWCZ fhDkLh"></span><span>Is_settled</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>status of settlement.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
               }
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>400 Bad request</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>404 Not found</span> </h5>
               </div>
            </div>
         </div>
      </div>
      <div class="col-md-4 extreme-rt-div">
         <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
            <div class="card">
               <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                     <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab1}>
                     <button> POST </button> /api/refund/post {TabCheck1 ?
                     <FaAngleUp />
                     :
                     <FaAngleDown />
                     }
               </div>
               </h5>
            </div>
            {
            TabCheck1 &&
            <div>
               <br />
               <div class="card-body">
                  <p class="mb-0">Production server (uses live data)</p>
                  <div class="api-div-bor">
                     <span>https://www.avantgardepayments.com</span><span
                        class="col-org">/agcore/api/refund/post</span>
                  </div>
                  <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                  <div class="api-div-bor">
                     <span>https://pguat.safexpay.com</span><span
                        class="col-org">/agcore/api/refund/post</span>
                  </div>
               </div>
            </div>
            }
         </div>
      </div>
      <RequestJSON/>
      <ResponseJSON/>
   </div>
</div>
</div>
</div>
)
}
export default RefundAPI